const isPreAccessProduct = ({ preAccessGroups, preAccessStartDate, preAccessEndDate, } = {}) => {
    return !!preAccessGroups && !!preAccessStartDate && !!preAccessEndDate;
};
export default isPreAccessProduct;
//# sourceMappingURL=isPreAccessProduct.js.map